import React from 'react';
import Slider from "react-slick";
import styles from './slickSliderText.module.css';
import { ArrowRight, ArrowLeft } from 'lucide-react';
import { parseStringTags } from '../../utils/textUtils';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";



const SlickSliderText = ({ paragraphs, isMobile }) => {
  var settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    //autoplaySpeed: 3000,
    appendDots: dots => (
        <div>
            <ul className={styles.dotsContainer}>
                {dots}
            </ul>
        </div>
        
    )

  };

  return (  
    <div className={isMobile ? styles.sliderContainerMobile : styles.sliderContainer} style={{ marginBottom: "2rem", width: "100%" }}>
        <Slider {...settings}>
            {paragraphs.map((paragraph, index) => (
                <div className={styles.paragraphContainer} key={index}>
                    <h3>{paragraph.title}</h3>
                    <p className={styles.description}>{parseStringTags(paragraph.description)}</p>
                </div>
            ))}
        </Slider>
    </div>
             
  );
};

export default SlickSliderText;